import lazyWithReload from '../../utils/lazyWithReload';
import createRecordDrawer from './createRecordDrawer';

const CrmCompanyDrawer = lazyWithReload(() => import('./CrmCompanyDrawer'), 'CrmCompanyDrawer');

/**
 * URL-driven `?companyId=<short>`.
 * API: useCrmCompanyDrawer() → { openCompany, closeCompany, version, bumpVersion, openCompanyId, navInfo, navGo }
 * Trang danh sách công ty gọi thêm useCrmCompanyDrawerNav() để popup có nút trước/sau.
 */
const { Provider, useDrawer, useDrawerNav } = createRecordDrawer({
  param: 'companyId',
  kind: 'company',
  Drawer: CrmCompanyDrawer,
  names: { open: 'openCompany', close: 'closeCompany', openId: 'openCompanyId' },
});

export const CrmCompanyDrawerProvider = Provider;
export const useCrmCompanyDrawer = useDrawer;
export const useCrmCompanyDrawerNav = useDrawerNav;
